import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { toast } from "react-toastify";

import getIsoStringFromTimestamp from "../../helper/getIsoStringFromTimestamp";
import { isItDev } from "../../helper/isItDev";
import { db } from "../firebase";
import { createUserLog } from "../logs";

const getAllNotificationForUser = async (uid: string) => {
  const notificationsQuery = query(
    collection(db, `users/${uid}/notifications`),
    orderBy("sentTime", "desc")
  );
  try {
    const notificationsDocs = await getDocs(notificationsQuery);
    if (!notificationsDocs.empty) {
      return notificationsDocs.docs.map((doc) => {
        let data = doc.data();
        // data = populateNotificationMetaData(data as Notification);
        return {
          id: doc.id,
          ...data,
          sentTime: getIsoStringFromTimestamp(data.sentTime),
        };
      });
    }
    return [];
  } catch (error) {
    isItDev() && toast.error("Something went wrong");
    await createUserLog(
      uid,
      "Error",
      "Error while fetching Notifications",
      {},
      "Notification Error"
    );
  }
};

export default getAllNotificationForUser;
